{
    "FullName": "Full Name:",
    "FullNamePlaceholder": "[Full Name Not Specified]",
    "UsernameHint": "The username doesn't need to be an email address but must be uniquely identifiable and is case sensitive",
    "UsernameIDOnTelSysHint": "Username cannot be edited for this subscription type. It must match the username on the Telephony Platform.",
    "UsernameEditHint": "When editing a username the password must be re-entered",
    "Email": "Email:",
    "EmailPlaceholder": "example@domain.com",
    "EmailHint": "Where the automatically generated email messages are sent to. (New user/Welcome emails, password resets and scheduled reports)",
    "Defaultlanguage": "Email Language:",
    "Timezone_Title": "Timezone:",
    "DefaultlanguageHint": "Sets the default language for the platform and corresponding emails",
    "Passwordchange": "Password Change Required:",
    "Welcomeemail": "Send Welcome Email:",
    "WelcomeemailHelp": "This option is available when a valid email address and password has been entered and the Password Change Required setting is enabled",
    "NameValidation": "Full name should be no longer than 100 characters",
    "UsernameRequiredValidation": "Username must not be blank",
    "UsernameMaxLengthValidation": "Username should be no longer than 255 characters",
    "UsernameMustBeSetFromDeviceValidation": "To get the username for this user type, please make sure the device is set on the permissions tab",
    "EmailPatternValidation": "Please enter a valid email address",
    "EmailRequiredValidation": "Email address must not be blank",
    "EmailMaxLengthValidation": "Email address should be no longer than 255 characters",
    "PasswordLengthValidation": "Password is too short",
    "PasswordRequiredValidation": "Password must not be blank",
    "PasswordStrengthValidation": "Password is not strong enough (make sure to include upper and lower case letters as well as numbers)",
    "UserDetailsLanguage_Username": "Username:",
    "UserDetailsLanguage_Password": "Password:",
    "UserDetailsLanguage_PasswordPlaceholder": "••••••••",
    "UserDetailsLanguage_MFA_Label": "Enable MFA:",
    "UserDetailsLanguage_MFAHelp": "Enabling Multi-Factor Authentication (MFA) means the user will be required to enter a code from their authenticator app when logging in.",
    "UserDetailsLanguage_CXIUser": "CXI User:",
    "UserDetailsLanguage_CXIData": "CXI Data:",
    "UserDetailsLanguage_CXIntegration": "CX Integration:",
    "UserDetailsLanguage_CXS_Subscription": "CX Score:",
    "UserDetailsLanguage_CXR_Subscription": "CX Record:",
    "UserDetailsLanguage_CXT_TranscribeCalls": "Transcribe calls:",
    "UserDetailsLanguage_CXT_NeedsCxsOrCxrLicence": "Needs a CX Score or CX Record licence.",
    "UserDetailsLanguage_CXT_NeedsCxsLicence": "Needs a CX Score licence.",
    "UserDetailsLanguage_CXS_Score_Enabled": "Device Scoring:",
    "UserDetailsLanguage_CXR_Record_Enabled": "Device Recording:",
    "UserDetailsLanguage_UserSubscriptions": "User Subscriptions",
    "UserDetailsLanguage_UserConfiguration": "User Configuration",
    "UserDetailsLanguage_CXR_ManagerNotAllowed": "CXR Manager needs a user type of None or Manager, so it has been changed to None.",
    "NAME": "UserDetailsLanguage"
}
